import { render, staticRenderFns } from "./ChangeResolution.vue?vue&type=template&id=eb07c916&"
import script from "./ChangeResolution.vue?vue&type=script&lang=js&"
export * from "./ChangeResolution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports